define(function (require) {

    /* ----------------------------------- [ Consts ] ----------------------------------- */
    var APPLICATION_TYPE = 'LPAudioController';

    var Logger = require("logger");
    var logger = Logger.getLogger(APPLICATION_TYPE);
    var AUDIO_STATES =  {PAUSE: 'pause', PLAY: 'play', ENDED: 'ended', DURATION: 'duration', ERROR: 'error'};
    /* ----------------------------------- [ Static ] ----------------------------------- */

    AudioController.applicationType = APPLICATION_TYPE;
    AudioController.prototype.AUDIO_STATES = AUDIO_STATES;

    /* ---------------------------------- [ Privates ] ---------------------------------- */

    var model = null;              // the application model.
    var audioStatusHandler = null;
    var currentAudio = null;


    /* ------------------------------- [ Class Definition ] ------------------------------- */

    function AudioController(applicationModel) {
        model = applicationModel;
    }

    /**
     * Download the audio file from the provided url and starts playing it.
     *
     * @param url The location of the audio file
     * @param timeInSeconds Optional. The time in seconds it should start playing the audio from
     * @param onAudioStatusChange Optional. Callback to register for audio status changes, e.g. stopped, error
     */
    AudioController.prototype.play = function (url, timeInSeconds, onAudioStatusChange) {
        timeInSeconds = timeInSeconds || 0;

        endedCurrent();

        audioStatusHandler = onAudioStatusChange;
        loadAudio(url, function() {
            if (onAudioStatusChange) {
                onAudioStatusChange(AUDIO_STATES.DURATION, currentAudio.duration);
            }
            doPlay(timeInSeconds);
        });
    };

    /**
     * Pauses the current audio playback
     */
    AudioController.prototype.pause = function () {
        pauseCurrent();
    };

    /**
     * Stops the current audio playback
     */
    AudioController.prototype.end = function () {
        endedCurrent();
    };

    /**
     * Gets the current playback time
     *
     * @returns the current playback time or 0 if there is no audio file currently played
     */
    AudioController.prototype.getCurrentTime = function () {
        if (currentAudio === null ) {
            return 0;
        }
        return currentAudio.currentTime;
    };

    /**
     * Sets the current playback time
     *
     * @param setTime the time that should be set
     */
    AudioController.prototype.setCurrentTime = function (setTime) {
        if (currentAudio === null) {
            return;
        }

        if(!isNaN(setTime) && !isNaN(currentAudio.duration)) {
            currentAudio.currentTime = setTime;
        }
    };


    /* ------------------------------ [ private functions ] ------------------------------ */

    function pauseCurrent() {
        if (audioStatusHandler && currentAudio) {
            // pause current one
            currentAudio.pause();
            audioStatusHandler(AUDIO_STATES.PAUSE);
        }
    }

    function endedCurrent() {
        if (audioStatusHandler && currentAudio) {
            currentAudio.pause();
            audioStatusHandler(AUDIO_STATES.ENDED);
        }
    }

    function loadAudio(url, onAudioLoaded){
        currentAudio = new Audio(url);
        var initialPlay = false;
        currentAudio.addEventListener('canplaythrough', function() {
            if (initialPlay) {
                return;
            }
            initialPlay = true;
            onAudioLoaded();
        });

        if (currentAudio.readyState > 3) {
            // in case the 'canplaythrough' has already been fired
            onAudioLoaded();
        }

        currentAudio.addEventListener('error', function(error) {
            handleAudioError(error);
        });

        currentAudio.addEventListener('ended', function() {
            endedCurrent();
            currentAudio.currentTime = 0;
            audioStatusHandler = null;
        });
    }

    function doPlay(timeInSeconds) {
        var promise = currentAudio.play();
        if (promise) {
            promise.then(function(){
                currentAudio.currentTime = timeInSeconds;
            }).catch(function(error) {
                handleAudioError(error);
            });
        } else {
            // Some browser like IE11 don't return a promise
            currentAudio.currentTime = timeInSeconds;
        }

        audioStatusHandler(AUDIO_STATES.PLAY);
    }

    function handleAudioError(error) {
        logger.error("Failed to play audio file", error);
        audioStatusHandler(AUDIO_STATES.ERROR);
    }

    /* ******************************************** */

    return AudioController;

});
